import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import {Paper,LinearProgress,Card,CardMedia} from 'material-ui';
import Typography from 'material-ui/Typography';
import Face from '@material-ui/icons/Face'
const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
    marginBottom:theme.spacing.unit * 3,
    textAlign:'left',
  }),
  cover: {
    minWidth:300,
    minHeight:300,padding:10,
  },
  p:{
      width:'100%',
      padding:0,
      // textIndent:28,
      lineHeight:'20px',
      wordWrap:'break-word', 
      wordBreak:'break-all'
  },icon:{
    position:'relative',
    top:6
  },
  card:{
    padding:10
  },
  pname:{
    width:'20%',
    display:'inline-block',
    float:'left',

  },
  description:{
    width:'80%',
    display:'inline-block',
  },
  clear:{
    clear:'both'
  }
});
function PaperSheet(props) {
  const { classes,prop } = props;
 let {MyIcon,title,paragraphs,profileImg}=prop
 let Plist=paragraphs.map((paragraph,index)=><Card  className={classes.card}  key={index.toString()}><Typography component="div"
      className={classes.p}>
      <div className={classes.pname}>{paragraph.name}:</div>
      <div className={classes.description}>{paragraph.description}</div>
      <div className={classes.clear}></div>
      {paragraph.level?<LinearProgress color="primary" variant="determinate" value={paragraph.level} />:''}
      </Typography>
      </Card>)
  return (
    <div>
      <Paper className={classes.root} elevation={4}>
        <Typography variant="headline" component="h3">
        {MyIcon?<MyIcon />:<Face  className={classes.icon}/>} {title}：
        </Typography>
        {profileImg?< CardMedia
          className={classes.cover}
          image={profileImg}
          title="Live from space album cover"
        />:''}
        {Plist}
      </Paper>
    </div>
  );
}

PaperSheet.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PaperSheet);


// WEBPACK FOOTER //
// ./src/components/paper.js